import {
  GET_FEED,
  UPDATE_FEED,
  GET_FEED_FIXTURES,
  GET_FEED_ARTICLES,
  GET_FEED_VIDEOS,
  REIMPORT_FEED_CONTENT,
  FLUSH_FEED_FIXTURES,
  GET_FEED_LOGS,
  UPDATE_ROUND_NAMES,
} from './actions';
import {
  SET_FEED,
  SET_FEED_FIXTURES,
  SET_FEED_ARTICLES,
  SET_FEED_ARTICLES_PAGE,
  SET_FEED_ARTICLES_QUERY,
  SET_FEED_VIDEOS,
  SET_FEED_VIDEOS_PAGE,
  SET_FEED_VIDEOS_QUERY,
  SET_FEED_LOGS,
} from './mutations';
import HTTP from './../lib/HTTP';

const state = {
  item: null,
  fixtures: null,
  articles: null,
  articles_page: 1,
  articles_query: '',
  videos: null,
  videos_page: 1,
  videos_query: '',
  logs: null,
};

const mutations = {
  [SET_FEED](_state, feed) {
    _state.fixtures = null;
    _state.articles = null;
    _state.articles_page = 1;
    _state.articles_query = '';
    _state.videos = null;
    _state.videos_page = 1;
    _state.videos_query = '';
    _state.logs = null;
    _state.item = feed;
  },
  [SET_FEED_FIXTURES](_state, fixtures) {
    _state.fixtures = fixtures;
  },
  [SET_FEED_ARTICLES](_state, articles) {
    if (articles === null) {
      _state.articles = null;
      return;
    }

    if (state.articles && typeof (state.articles) === typeof ([])) {
      _state.articles = _state.articles.concat(articles);
    }
    else {
      _state.articles = articles;
    }
  },
  [SET_FEED_ARTICLES_PAGE](_state, page) {
    _state.articles_page = page;
  },
  [SET_FEED_ARTICLES_QUERY](_state, query) {
    _state.articles_query = query;
    _state.articles_page = 1;
    _state.articles = null;
  },
  [SET_FEED_VIDEOS](_state, videos) {
    if (state.videos && typeof (state.videos) === typeof ([])) {
      _state.videos = _state.videos.concat(videos);
    }
    else {
      _state.videos = videos;
    }
  },
  [SET_FEED_VIDEOS_PAGE](_state, page) {
    _state.videos_page = page;
  },
  [SET_FEED_VIDEOS_QUERY](_state, query) {
    _state.videos_query = query;
    _state.videos_page = 1;
    _state.videos = null;
  },
  [SET_FEED_LOGS](_state, logs) {
    _state.logs = logs;
  }
};

const actions = {
  [GET_FEED](context, feedId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`feeds/${feedId}`).then((res) => {
        if (res && res.data) {
          context.commit(SET_FEED, res.data);
        }
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },
  [GET_FEED_FIXTURES](context, params) {
    return new Promise((resolve, reject) => {
      let url = `feeds/${params.feedId}/fixtures`;
      if (params.status) {
        url += `?status=${params.status}`;
      }

      HTTP.get(url).then((res) => {
        if (res && res.data && res.data.content) {
          context.commit(SET_FEED_FIXTURES, res.data.content);
        }
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },
  [GET_FEED_ARTICLES](context, feedId) {
    return new Promise((resolve, reject) => {
      let url = `feeds/${feedId}/articles?page=${context.state.articles_page}`;
      if (context.state.articles_query && context.state.articles_query.trim().length) {
        url += `&query=${context.state.articles_query}`
      }

      HTTP.get(url).then((res) => {
        if (res && res.data && res.data.content) {
          context.commit(SET_FEED_ARTICLES, res.data.content);
          context.commit(SET_FEED_ARTICLES_PAGE, context.state.articles_page + 1);
        }
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },
  [GET_FEED_VIDEOS](context, feedId) {
    return new Promise((resolve, reject) => {
      let url = `feeds/${feedId}/videos?page=${context.state.videos_page}`;
      if (context.state.videos_query && context.state.videos_query.trim().length) {
        url += `&query=${context.state.videos_query}`;
      }

      HTTP.get(url).then((res) => {
        if (res && res.data && res.data.content) {
          context.commit(SET_FEED_VIDEOS, res.data.content);
          context.commit(SET_FEED_VIDEOS_PAGE, context.state.videos_page + 1);
        }
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },
  [GET_FEED_LOGS](context, feedId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`feeds/${feedId}/logs`).then((res) => {
        if (res && res.data) {
          context.commit(SET_FEED_LOGS, res.data);
        }
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },
  [UPDATE_FEED](context, feed) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`feeds/${feed.id}`, feed).then((res) => {
        if (res && res.status === 204) {
          context.commit(SET_FEED, null);
          context.dispatch(GET_FEED, feed.id);
        }
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },
  [REIMPORT_FEED_CONTENT](context, options) {
    return new Promise((resolve, reject) => {
      HTTP.post(`feeds/${options.id}/reimport`, options).then((res) => {
        if (res && res.status === 200) {
          if (options.reimport_type === 'articles') {
            context.commit(SET_FEED_ARTICLES, null);
            context.commit(SET_FEED_ARTICLES_PAGE, 1);
            context.dispatch(GET_FEED_ARTICLES, options.id);
          }
          else if (options.reimport_type === 'fixtures') {
            context.commit(SET_FEED_FIXTURES, null);
            context.dispatch(GET_FEED_FIXTURES, { feedId: options.id });
          }
        }
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },
  [FLUSH_FEED_FIXTURES](context, id) {
    return new Promise((resolve, reject) => {
      HTTP.post(`feeds/${id}/flush_fixtures`, { id: id }).then((res) => {
        if (res && res.status === 200) {
          context.commit(SET_FEED_FIXTURES, null);
          context.dispatch(GET_FEED_FIXTURES, { feedId: id });
        }
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },
  [UPDATE_ROUND_NAMES](content, payload){
    return new Promise((resolve, reject) => {
      HTTP.post(`fixtures/update_round_names`, payload).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  }
};

export default {
  state,
  mutations,
  actions,
};
